import { render, staticRenderFns } from "./PartnerCardsTable.vue?vue&type=template&id=5c970a22&scoped=true"
import script from "./PartnerCardsTable.vue?vue&type=script&lang=js"
export * from "./PartnerCardsTable.vue?vue&type=script&lang=js"
import style0 from "./PartnerCardsTable.vue?vue&type=style&index=0&id=5c970a22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c970a22",
  null
  
)

export default component.exports